'use client';

import { Alert, Button, Container, Divider, Stack, TextField, Typography } from '@mui/material';
import PasswordField from 'components/auth/PasswordField';
import { signInAction } from 'app/actions/login';
import { signIn } from 'next-auth/react';
import GoogleIcon from '@mui/icons-material/Google';
import { useActionState } from 'react';

export const dynamic = 'force-dynamic';

export default function LoginPage() {
  const [state, formAction, pending] = useActionState(signInAction, { error: '' });

  const handleGoogleSignIn = () => {
    signIn('google', { callbackUrl: '/' });
  };

  return (
    <Container
      maxWidth="sm"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: '600px',
      }}
    >
      <Stack spacing={3} sx={{ width: '100%' }}>
        <Button
          variant="outlined"
          fullWidth
          startIcon={<GoogleIcon />}
          onClick={handleGoogleSignIn}
          sx={{ height: '48px' }}
        >
          Sign in with Google
        </Button>

        <Stack direction="row" alignItems="center" spacing={2}>
          <Divider sx={{ flex: 1 }} />
          <Typography variant="body2" color="text.secondary">
            or
          </Typography>
          <Divider sx={{ flex: 1 }} />
        </Stack>

        <form action={formAction}>
          <Stack spacing={3}>
            {state?.error && <Alert severity="error">{state.error}</Alert>}

            <TextField
              fullWidth
              required
              name="email"
              type="email"
              label="Email"
              autoComplete="email"
            />

            <PasswordField
              name="password"
              autoComplete="current-password"
              showRequirementsValidation={false}
            />
            <input type="hidden" name="redirectTo" value="/" />

            <Button type="submit" variant="contained" fullWidth disabled={pending}>
              {pending ? 'Signing in...' : 'Sign In with Email'}
            </Button>
          </Stack>
        </form>
      </Stack>
    </Container>
  );
}
